import { render, staticRenderFns } from "./FibrePlanner.vue?vue&type=template&id=b3b80e10&scoped=true&"
import script from "./FibrePlanner.vue?vue&type=script&lang=js&"
export * from "./FibrePlanner.vue?vue&type=script&lang=js&"
import style0 from "./FibrePlanner.vue?vue&type=style&index=0&id=b3b80e10&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b80e10",
  null
  
)

export default component.exports